import React, { useState } from 'react'
import Head from '../../layouts/main-layout/head/Head'
import { Controller, useForm } from 'react-hook-form';
import { IoCheckbox } from 'react-icons/io5';
import { MdCheckBox, MdCheckBoxOutlineBlank, MdOutlineCheckBox, MdOutlineCheckBoxOutlineBlank, MdOutlineRadioButtonChecked, MdOutlineRadioButtonUnchecked } from 'react-icons/md';
import { Row } from 'react-bootstrap';
import { SubmitPaidDemoRequest, useAuthCompany } from '../../services/AppServices';
import RSelect from '../common/RSelect'
import { toast } from 'react-toastify';

const PaidDemo = () => {
    const [isConsent, setConsent] = useState(false);
    const [isSessionLoading, setSessionLoading] = useState(false)
    const [selectedSubjects, setSelectedSubjects] = useState([]);
    const [selectedClass, setSelectedClass] = useState(null);
    const [selectedBoard, setSelectedBoard] = useState(null);
    const { companyData } = useAuthCompany();
    const [classList, setClassList] = useState([{ label: "Class Three", value: "Class Three" }, { label: "Class Four", value: "Class Four" }, { label: "Class Five", value: "Class Five" }, { label: "Class Six", value: "Class Six" }, { label: "Class Seven", value: "Class Seven" }, { label: "Class Eight", value: "Class Eight" }, { label: "Class Nine", value: "Class Nine" }, { label: "Class Ten", value: "Class Ten" }, { label: "Class Eleven", value: "Class Eleven" }, { label: "Class Twelve", value: "Class Twelve" }])


    const {
        control,
        reset,
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        watch,
        unregister,
    } = useForm();


    const onSubmitData = (data) => {
        if (!isConsent) {
            alert("Please provide consent to proceed.");
            return;
        }

        data.affiliateId = companyData?.affiliate_id;
        data.userInterests = data.subjects;
        data.userAddress = data.userDescription;
        data.callbackUrl = "https://quadnut.org/verify-paid-demo-payment";
        data.userClass = data.studentClass;

        setSessionLoading(true);
        SubmitPaidDemoRequest(data)
            .then((res) => {
                window.location.href = res?.data?.url;
            }).catch((err) => {
                toast.error(err?.response?.data?.message)
            }).finally(() => {
                setSessionLoading(false)
            })
    };

    const subjects = ["Mathematics", "Science", "Computer", "English"];
    const classes = ["Class 3rd to 8th", "Class 9th to 12th"];
    const boards = ["CBSE", "ICSE", "State Board"];

    const onToggleSubject = (subject) => {
        let tempSelectedSubjects = [...selectedSubjects];
        if (selectedSubjects.includes(subject)) {
            setSelectedSubjects([...tempSelectedSubjects.filter((elem) => elem != subject)])
        } else {
            tempSelectedSubjects.push(subject);
            setSelectedSubjects([...tempSelectedSubjects])
        }
    }

    return (<>
        <Head title='Book Demo Class' />
        <div className="container py-5 mocktest top-spacing">
            <div className="row align-items-center mb-4">
                <div className="col-lg-12 text-center text-lg-center px-5">
                    <h1 className="fw-bold heading"> Join Our Demo Class for Just ₹19!</h1>
                    <h4 className="subheading"> Presenting Best To You !</h4>
                    <p className='text-justify text-lg-justified'>
                        Experience quality learning at a minimal cost! Enroll in our exclusive demo class for only ₹19 and get a firsthand look at our teaching style, course content, and expert instructors. Limited-time offer — don’t miss out!
                    </p>
                    <button className="btn btn-box mt-3 btn-custom">Book A Demo</button>
                </div>
            </div>
            <section className=''>
                <div className="container">
                    <div className="col-xl-12">
                        <div className="rounded-0">
                            <div className="row gy-2">
                                <div className="col-lg-12 d-flex justify-content-center">
                                    <div className="card session-card bg-white rounded-3 py-md-5 px-md-4 p-3 mx-2 mx-md-0 mb-0">
                                        <div className="row gy-3">
                                            <div className="col-xl-12">
                                                <form onSubmit={handleSubmit(onSubmitData)} className="session-from">
                                                    <div className="row gy-3">
                                                        {/* Name */}
                                                        <div className="col-xl-6">
                                                            <input
                                                                {...register("userName", {
                                                                    required: "Name is required",
                                                                    pattern: {
                                                                        value: /^(?=.*[a-zA-Z]{3,}).*$/,
                                                                        message: "Please enter a valid name",
                                                                    },
                                                                })}
                                                                className="form-control"
                                                                placeholder="Enter your Name"
                                                            />
                                                            {errors.userName && (
                                                                <span className="error-italic">{errors.userName.message}</span>
                                                            )}
                                                        </div>

                                                        {/* Mobile Number */}
                                                        <div className="col-xl-6">
                                                            <input
                                                                {...register("userNumber", {
                                                                    required: "Contact no. is required",
                                                                    pattern: {
                                                                        value: /^[6-9][0-9]{9}$/,
                                                                        message: "Phone number must be valid and of 10 digits",
                                                                    },
                                                                })}
                                                                className="form-control"
                                                                placeholder="Enter your Mobile Number"
                                                            />
                                                            {errors.userNumber && (
                                                                <span className="error-italic">{errors.userNumber.message}</span>
                                                            )}
                                                        </div>

                                                        {/* Subjects */}
                                                        <div className="col-xl-12 interests-container">
                                                            <div className="row">
                                                                <label className="form-label">Subjects</label>
                                                                {subjects.map((subject, idx) => (
                                                                    <div className="col-xl-3" key={idx}>
                                                                        <div className="interest-options">
                                                                            <div className="mode-option pb-0">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    value={subject}
                                                                                    {...register("subjects", {
                                                                                        required: "Select at least one subject",
                                                                                    })}
                                                                                    className="d-none"
                                                                                    id={`subject-${idx}`}
                                                                                />
                                                                                <label htmlFor={`subject-${idx}`} className="d-flex align-items-center clickable-btn" onClick={() => onToggleSubject(subject)}>
                                                                                    {
                                                                                        selectedSubjects.includes(subject) ?
                                                                                            <MdCheckBox className="interest-icon" /> :
                                                                                            <MdCheckBoxOutlineBlank className="interest-icon" />
                                                                                    }
                                                                                    <span className="interest-label">{subject}</span>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                                {errors.subjects && (
                                                                    <span className="error-italic">{errors.subjects.message}</span>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {/* Class Selection */}
                                                        <div className="col-xl-12 col-md-12">
                                                            <label className="form-label mb-2">Student Class / Std.</label>
                                                            <Controller
                                                                name="studentClass"
                                                                control={control}
                                                                rules={{ required: "Please select a class" }}
                                                                render={({ field, fieldState }) => (
                                                                    <RSelect
                                                                        {...field}
                                                                        className="session-form-select-round"
                                                                        options={classList}
                                                                        placeholder="Student Class / Standard"
                                                                        value={field.value ? { label: field.value, value: field.value } : null}
                                                                        onChange={(selectedOption) => { field.onChange(selectedOption.value) }}
                                                                        styles={{
                                                                            control: (base, state) => ({
                                                                                ...base,
                                                                                borderColor: state.isFocused ? '#d4145a7d' : base.borderColor,
                                                                                boxShadow: state.isFocused ? '0 0 0 1px #d4145a7d' : base.boxShadow,
                                                                                borderRadius: "25px",
                                                                                '&:hover': {
                                                                                    borderColor: state.isFocused ? '#d4145a7d' : base.borderColor,
                                                                                },
                                                                            }),
                                                                            option: (base, state) => ({
                                                                                ...base,
                                                                                backgroundColor: state.isFocused
                                                                                    ? '#ffe6e6'
                                                                                    : state.isSelected
                                                                                        ? '#ffcccc'
                                                                                        : 'white',
                                                                                color: 'black',
                                                                                '&:active': {
                                                                                    backgroundColor: '#d4145a7d',
                                                                                },
                                                                            }),
                                                                        }}
                                                                    />
                                                                )}
                                                            />

                                                            {errors.studentClass && (
                                                                <span className="error-italic">{errors.studentClass.message}</span>
                                                            )}

                                                        </div>

                                                        {/* Board Selection */}
                                                        <div className="col-xl-12 interests-container">
                                                            <div className="row">
                                                                <label className="form-label">Board</label>
                                                                {boards.map((board, idx) => (
                                                                    <div className="col-xl-4" key={idx}>
                                                                        <div className="interest-options">
                                                                            <div className="mode-option pb-0">
                                                                                <input
                                                                                    type="radio"
                                                                                    value={board}
                                                                                    {...register("board", {
                                                                                        required: "Please select a board",
                                                                                    })}
                                                                                    className="d-none"
                                                                                    id={`board-${idx}`}
                                                                                />
                                                                                <label htmlFor={`board-${idx}`} onClick={() => setSelectedBoard(board)} className="d-flex align-items-center clickable-btn">
                                                                                    {
                                                                                        selectedBoard == board ? <MdOutlineRadioButtonChecked className="interest-icon" /> :
                                                                                            <MdOutlineRadioButtonUnchecked className='interest-icon' />
                                                                                    }
                                                                                    <span className="interest-label">{board}</span>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                                {errors.board && (
                                                                    <span className="error-italic">{errors.board.message}</span>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {/* Address */}
                                                        <div className="col-xl-12 col-md-12">
                                                            <textarea
                                                                className="form-control session-form-select-round"
                                                                rows={5}
                                                                {...register("userDescription", {
                                                                    required: "Address is required",
                                                                })}
                                                                placeholder="Student Address ..."
                                                            />
                                                            {errors.userDescription && (
                                                                <span className="error-italic">{errors.userDescription.message}</span>
                                                            )}
                                                        </div>

                                                        {/* Consent */}
                                                        <div className="col-xl-12">
                                                            <div
                                                                className="interest-option border-0"
                                                                onClick={() => setConsent(!isConsent)}
                                                            >
                                                                {isConsent ? (
                                                                    <IoCheckbox className="interest-icon" />
                                                                ) : (
                                                                    <MdOutlineCheckBoxOutlineBlank className="interest-icon" />
                                                                )}
                                                                <span className="interest-label">
                                                                    I agree to receive communication from QuadNut Champs regarding Demo Inquiry, student profiling and career guidance.
                                                                </span>
                                                            </div>
                                                        </div>

                                                        {/* Submit Button */}
                                                        <div className="col-xl-12">
                                                            <button
                                                                type="submit"
                                                                className="btn w-100 schedule-btn py-2 border-0"
                                                                disabled={isSessionLoading}
                                                            >
                                                                {isSessionLoading ? "Submiting..." : "Submit"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        </div>
    </>)
}

export default PaidDemo;